export default __webpack_public_path__ + "static/IDMC_GRID_2022 Un primer vistazo-Número total de desplazados internos-c6e8358a126de85dd225640916b59dd6.jpg";